/* eslint-disable no-undef */
import TeaserWidget from '@components/TeaserWidget.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'
import VehicleSetup from '@components/vehicle-setup/VehicleSetup.vue'
import NoMembershipPage from '@components/NoMembershipPage.vue'
import NoVehiclesPage from '@components/NoVehiclesPage.vue'
import TripAdd from '@components/trip-detail/TripAdd.vue'
import TripEdit from '@components/trip-detail/TripEdit.vue'
import MyTrips from '@components/MyTrips.vue'
import AddFuelStop from '@components/fuel-stop/FuelStopAdd.vue'
import EditFuelStop from '@components/fuel-stop/FuelStopEdit.vue'
import Statistic from '@components/Statistic.vue'
import CarHealthScreen from '@components/CarHealthScreen.vue'
import SettingsScreen from '@components/SettingsScreen.vue'
import PilotsOverview from '@components/settings/pilot/PilotsOverview.vue'
import PilotEdit from '@components/settings/pilot/PilotEdit.vue'
import PilotAdd from '@components/settings/pilot/PilotAdd.vue'
import TagsOverview from '@components/settings/tag/TagsOverview.vue'
import TagEdit from '@components/settings/tag/TagEdit.vue'
import TagAdd from '@components/settings/tag/TagAdd.vue'
import ZonesOverview from '@components/settings/zone/ZonesOverview.vue'
import ZoneEdit from '@components/settings/zone/ZoneEdit.vue'
import ZoneAdd from '@components/settings/zone/ZoneAdd.vue'
import RulesOverview from '@components/settings/rule/RulesOverview.vue'
import RuleEdit from '@components/settings/rule/RuleEdit.vue'
import RuleAdd from '@components/settings/rule/RuleAdd.vue'
import MaintenanceOverview from '@components/settings/maintenance-items/MaintenanceOverview.vue'
import MaintenanceEdit from '@components/settings/maintenance-items/MaintenanceEdit.vue'
import InformationOverview from '@components/settings/information/InformationOverview.vue'
import InstallationGuide from '@components/settings/information/InstallationGuide.vue'
import { scrollIntoPage } from '@util/scrollUtils'
import getBasePath from '@util/path'

Vue.use(VueRouter)

export interface RouterState {
  name?: string | null
  path: string
  hash: string
  query: Record<string, string | (string | null)[]>
  params: Record<string, string>
  fullPath: string
  meta?: any
  from?: RouterFrom
}

export type RouterQuery = Record<string, string | (string | null)[]>
export type RouterFrom = Omit<RouterState, 'from'>

export default new VueRouter({
  mode: 'history',
  base: getBasePath(),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      window.scrollTo(savedPosition.x, savedPosition.y)
    } else if (to.name !== from.name) {
      scrollIntoPage()
    }
  },
  routes: [
    {
      path: '/',
      name: 'myTrips',
      component: MyTrips,
    },
    {
      path: '/setup/:id',
      name: 'vehicleSetup',
      component: VehicleSetup,
    },
    {
      path: '/keine-mitgliedschaft',
      name: 'noMembershipPage',
      props: true,
      component: NoMembershipPage,
    },
    {
      path: '/kein-fahrzeug',
      name: 'noVehiclesPage',
      component: NoVehiclesPage,
    },
    {
      path: '/teaser-widget/:id?',
      name: 'teaserWidget',
      component: TeaserWidget,
    },
    {
      path: '/hinzufuegen',
      name: 'myTripsAdd',
      component: TripAdd,
    },
    {
      path: '/betankung-hinzufuegen',
      name: 'fuelStopAdd',
      component: AddFuelStop,
    },
    {
      path: '/betankungen/:id',
      name: 'fuelStopEdit',
      component: EditFuelStop,
    },
    {
      path: '/statistik',
      name: 'myTripsStatistic',
      component: Statistic,
    },
    {
      path: '/health',
      name: 'myCarHealth',
      component: CarHealthScreen,
    },
    {
      path: '/anpassen',
      name: 'mySettings',
      component: SettingsScreen,
    },
    {
      path: '/anpassen/personen',
      name: 'pilotsOverview',
      component: PilotsOverview
    },
    {
      path: '/anpassen/personen/hinzufuegen',
      name: 'pilotsAdd',
      component: PilotAdd
    },
    {
      path: '/anpassen/personen/:id',
      name: 'pilotEdit',
      component: PilotEdit
    },
    {
      path: '/anpassen/kategorien',
      name: 'tagsOverview',
      component: TagsOverview
    },
    {
      path: '/anpassen/kategorien/hinzufuegen',
      name: 'tagsAdd',
      component: TagAdd
    },
    {
      path: '/anpassen/kategorien/:id',
      name: 'tagEdit',
      component: TagEdit
    },
    {
      path: '/anpassen/zonen',
      name: 'zonesOverview',
      component: ZonesOverview
    },
    {
      path: '/anpassen/zonen/hinzufuegen',
      name: 'zonesAdd',
      component: ZoneAdd
    },
    {
      path: '/anpassen/zonen/:id',
      name: 'zoneEdit',
      component: ZoneEdit
    },
    {
      path: '/anpassen/regeln',
      name: 'rulesOverview',
      component: RulesOverview
    },
    {
      path: '/anpassen/regeln/hinzufuegen',
      name: 'rulesAdd',
      component: RuleAdd
    },
    {
      path: '/anpassen/regeln/:id',
      name: 'ruleEdit',
      component: RuleEdit
    },
    {
      path: '/anpassen/erinnerungen',
      name: 'maintenanceOverview',
      component: MaintenanceOverview
    },
    {
      path: '/anpassen/erinnerungen/:id',
      name: 'maintenanceEdit',
      component: MaintenanceEdit
    },
    {
      path: '/anpassen/erinnerungen/hinzufuegen',
      name: 'maintenanceAdd',
      component: MaintenanceEdit
    },
    {
      path: '/anpassen/informationen',
      name: 'informationOverview',
      component: InformationOverview
    },
    {
      path: '/anpassen/setup',
      name: 'installationGuide',
      component: InstallationGuide
    },
    {
      path: '/:id',
      name: 'myTripsEdit',
      component: TripEdit,
    },
  ],
})
